var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7356 2.30021L2.31879 6.48803C1.63779 7.13373 2.1201 8.23777 3.08319 8.23777H5.39201V16.975C5.39201 17.5411 5.876 18 6.47303 18H8.52697C9.124 18 9.60799 17.5411 9.60799 16.975V8.23777H11.9168C12.8799 8.23777 13.3622 7.13373 12.6812 6.48803L8.2644 2.30021C7.84223 1.89993 7.15777 1.89993 6.7356 2.30021Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7356 21.6998L11.3188 17.512C10.6378 16.8663 11.1201 15.7622 12.0832 15.7622H14.392V7.02497C14.392 6.4589 14.876 6 15.473 6H17.527C18.124 6 18.608 6.4589 18.608 7.02497V15.7622H20.9168C21.8799 15.7622 22.3622 16.8663 21.6812 17.512L17.2644 21.6998C16.8422 22.1001 16.1578 22.1001 15.7356 21.6998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.fd193fa7acc41e16160db2cc2ca0a927.svg";
export { ForwardRef as ReactComponent };